<template>
    <layout :showuserinfo="false" title="Daftar Ampun Hasil" :crumbs="crumbs">
        <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">mdi mdi-tune</w-icon>
                Carian Hak Milik
            </template>
            <w-flex class="justify-end">
                <div class="xs4 mr3">
                    <w-select
                        class="mb3"
                        :items="districts"
                        v-model="form.kod_daerah"
                        outline
                        label="Pilih Daerah"
                        label-position="left"
                        @input="fetchData1()"
                    >
                    </w-select>
                </div>
            </w-flex>
            <w-form @submit.prevent="submit">
                <w-flex class="mt3">
                    <div class="xs2">
                        <w-radio
                            class="mr2"
                            v-model="form.form_option"
                            name="radio"
                            return-value="option1"
                        >
                            Barcode
                        </w-radio>
                    </div>
                    <div class="xs10 mr3">
                        <w-input
                            v-model="form.barcode"
                            placeholder="Sila Masukkan Barcode"
                            :disabled="form.form_option !== 'option1'"
                            :validators="[validators.required]"
                            maxlength="30"
                        ></w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option2"
                        >
                            ID Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs3 mr3">
                        <w-select
                            :validators="[validators.required]"
                            placeholder="Sila Pilih Kod Mukim"
                            v-model="form.kod_mukim"
                            :items="mukim"
                            value="01"
                            :disabled="form.form_option !== 'option2'"
                        />
                    </div>
                    <div class="xs3 mr3">
                        <w-select
                            :validators="[validators.required]"
                            placeholder="Sila Pilih Jenis Hakmilik"
                            v-model="form.kod_jenis_hm"
                            :items="jhm"
                            :disabled="form.form_option !== 'option2'"
                        />
                    </div>
                    <div class="xs4 mr3">
                        <w-input
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option2' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option2'"
                            :validators="[
                                form.form_option === 'option2'
                                    ? validators.required
                                    : null,
                            ]"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_petak
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>

                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option3"
                        >
                            Mukim dan No. Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs5 mr3">
                        <w-select
                            :validators="[
                                form.form_option === 'option3'
                                    ? validators.required
                                    : null,
                            ]"
                            placeholder="Sila Pilih Kod Mukim"
                            v-model="form.kod_mukim"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.kod_mukim
                            "
                            :items="mukim"
                            :disabled="form.form_option !== 'option3'"
                        />
                    </div>
                    <div class="xs5 mr3">
                        <w-input
                            :validators="[
                                form.form_option === 'option3'
                                    ? validators.required
                                    : null,
                            ]"
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option3' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_petak
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>

                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option4"
                        >
                            Jenis dan No. Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs5 mr3">
                        <w-select
                            :validators="[
                                form.form_option === 'option4'
                                    ? validators.required
                                    : null,
                            ]"
                            placeholder="Sila Pilih Jenis Hakmilik"
                            v-model="form.kod_jenis_hm"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.kod_jenis_hm
                            "
                            :items="jhm"
                            :disabled="form.form_option !== 'option4'"
                        />
                    </div>
                    <div class="xs5 mr3">
                        <w-input
                            :validators="[
                                form.form_option === 'option4'
                                    ? validators.required
                                    : null,
                            ]"
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option4' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>
                <div class="d-flex justify-end mt3">
                    <w-button
                        class="my1 mr0"
                        type="submit"
                        :loading="searching"
                    >
                        Semak Cukai
                    </w-button>
                </div>
            </w-form>
        </w-dialog>
        <center>
            <h4 v-if="hasSearched && !no_hm" class="ma1">
                Tiada Rekod Ditemui
            </h4>
        </center>
        <z-page
            title="Daftar Ampun Hasil"
            :append-button="true"
            icon="fal fa-database"
        >
            <w-form @success="daftarAmpun">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-tooltip color="primary">
                            <template #activator="{ on }">
                                <w-badge
                                    style="width: 20%"
                                    class="mr10"
                                    round
                                    top
                                    right
                                    xs
                                >
                                    <template #badge>
                                        <w-icon
                                            v-on="on"
                                            @click="dialog.show = true"
                                            >wi-plus</w-icon
                                        >
                                        <!-- <w-button
                      @click="showAlert = !showAlert"
                      icon="wi-plus"
                      bg-color="primary"
                      sm
                    >
                    </w-button> -->
                                    </template>
                                    <label style="color: grey"
                                        >No Hak Milik</label
                                    >
                                </w-badge>
                            </template>
                            Klik Untuk Carian Hak Milik
                        </w-tooltip>
                        <w-input
                            v-model="no_hm"
                            :validators="[validators.required]"
                            disabled
                            style="color: blue; width: 100%"
                        >
                        </w-input>
                    </div>

                    <div class="xs6 mr3">
                        <w-tooltip color="primary">
                            <template #activator="{ on }">
                                <w-badge
                                    style="width: 20%"
                                    class="mr10"
                                    round
                                    top
                                    right
                                >
                                    <template #badge>
                                        <w-icon v-on="on">
                                            fal fa-info-circle</w-icon
                                        >
                                    </template>
                                    <label style="color: grey">No Akaun</label>
                                </w-badge>
                            </template>
                            Tidak Boleh Diubah
                        </w-tooltip>

                        <w-input
                            :validators="[validators.required]"
                            :placeholder="[[hmAkaun]]"
                            disabled
                            style="color: blue; width: 100%"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukkan No. MMK"
                            v-model="daftar.no_tauliah"
                            >No. MMK</w-input
                        >
                    </div>

                    <div class="xs6">
                        <w-select
                            label="Pemilik"
                            placeholder="Sila Pilih Pemilik"
                            v-model="daftar.profil_id"
                            :items="pemiliks"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3 mb5">
                    <div class="xs6 mr3">
                        <w-input type="date" v-model="daftar.tarikh_mula"
                            >Tarikh Mula</w-input
                        >
                    </div>
                    <div class="xs6">
                        <w-input
                            type="date"
                            v-model="daftar.tarikh_tamat"
                            :validators="[validators.required]"
                            >Tarikh Tamat</w-input
                        >
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-select
                            label="Kategori"
                            placeholder="Sila Pilih Kategori"
                            v-model="daftar.lkp_hm_ampun_hasil_id"
                            :items="kodKategori"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            type="file"
                            placeholder="Muat Naik Watikah"
                            v-on:change="onFileChange($event)"
                        >
                            Watikah
                        </w-input>
                    </div>
                </w-flex>

                <table class="mb2 table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Kod Hasil</td>
                            <td>Keterangan</td>
                            <td>Amaun (RM)</td>
                            <td>Amaun Ampun Hasil (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ cukais13.kod_hasil }}
                            </td>
                            <td>
                                {{ cukais13.keterangan }}
                            </td>
                            <td>
                                {{ cukais13.amaun_debit }}
                            </td>
                            <td>
                                <w-input
                                    v-model="daftar.amaun13"
                                    type="number"
                                    :validators="[validators.required]"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{ cukais28.kod_hasil }}
                            </td>
                            <td>
                                {{ cukais28.keterangan }}
                            </td>
                            <td>
                                {{ cukais28.amaun_debit }}
                            </td>
                            <td>
                                <w-input
                                    v-model="daftar.amaun28"
                                    type="number"
                                    :validators="[validators.required]"
                                />
                            </td>
                        </tr>
                        <tr style="background-color:#23478110">
                            <td colspan="3" style="text-align: right;">
                                JUMLAH AMAUN AMPUN HASIL
                            </td>
                            <td class="text-left">
                                {{ daftar.amaun13 + daftar.amaun28  }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-end mt3">
                    <w-button :loading="registering" class="my1 mr0" type="submit"
                        >Daftar Ampun Hasil</w-button
                    >
                </div>
            </w-form>
        </z-page>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import { Inertia } from "@inertiajs/inertia";
import _ from "lodash";

export default {
    extends: ZResource,
    components: {},
    props: {},
    data() {
        return {
            valid: null,
            validators: {
                required: (value) => !!value || "Sila Isi Ruangan Ini",
                // Other validators...
            },
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Daftar Ampun Hasil",
                    route: "/cukai-tanah/daftarAmpunHasil",
                },
            ],

            districts: [{ label: "Loading", selected: true }],
            mukim: [{ label: "Loading", selected: true }],
            jhm: [{ label: "Loading", selected: true }],
            daftar: {
                hm_akaun_id: null,
                lkp_hm_ampun_hasil_id: null,
                keluasan: null,
                no_tauliah: null,
                tarikh_mula: null,
                tarikh_tamat: null,
                // amaun_cukai: null,
                amaun13: 0,
                amaun28: 0,
                // peratus_ampun: 0,
                status: 1,
                profil_id: null,
            },
            form: {
                kod_daerah: "01",
                form_option: "option1",
                kategori_carian: "1",
                barcode: null,
                kod_mukim: "01",
                kod_jenis_hm: null,
                no_hm: "",
                no_bangunan: null,
                no_tingkat: null,
                no_petak: null,
                no_resit: null,
                no_kp: null,
            },
            file: "",
            search: {
                keyword: "",
                is_cukai_tanah: "",
            },
            searching: false,
            hasSearched: false,
            no_hm: null,
            hmAkaun: null,
            dialog: {
                show: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 1000,
            },
            kodKategori: [{ label: "Loading", selected: true }],
            pemiliks: [{ label: "Loading", selected: true }],
            cukais13: {},
            cukais28: {},
            registering: false
        };
    },
    methods: {
        onFileChange(e) {
            console.log(e.target.files[0]);
            this.file = e.target.files[0];
        },
        kembali() {
            window.history.back();
        },
        async kategori() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenis-ampun-hasil`,
                responseType: "json",
            }).then((e) => {
                this.kodKategori = e.data.map((d) => {
                    return { label: d.id + " - " + d.keterangan, value: d.id };
                });
            });
        },
        async daftarAmpun(e) {
            this.registering = true;
            let formData = new FormData();
            formData.append("file", this.file);

            _.each(this.daftar, (value, key) => {
                formData.append(key, value);
            });

            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil`,
                responseType: "json",
                data: formData,
                headers: { "content-type": "multipart/form-data" },
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        Inertia.get("/cukai-tanah/ampun-hasil");
                    }
                })
                .catch((err) => {
                    this.$waveui.notify({
                        error: true,
                        message: "Ralat",
                        timeout: 3000,
                    });
                    return;
                })
                .finally((e) => {
                    this.registering = false
                });
        },
        async submit() {
            if (this.form.barcode != null || this.form.no_hm != null) {
                this.cukai = [];
                this.hasSearched = false;
                this.searching = true;

                await axios({
                    method: "post",
                    url: `${this.apiBaseUrl}/cukai/cari`,
                    responseType: "json",
                    data: this.form,
                })
                    .then((e) => {
                        if (e.data.length > 0) {
                            // console.log(e.data[0]);
                            this.no_hm = e.data[0].no_hm;
                            this.hmAkaun = e.data[0].no_akaun;
                            this.daftar.keluasan = e.data[0].keluasan;
                            this.daftar.hm_akaun_id = e.data[0].id;
                            this.pemiliks = e.data[0].pemiliks.map((d) => {
                                return {
                                    label: d.id + " - " + d.nama,
                                    value: d.id,
                                };
                            });
                            this.dialog.show = false;
                            const cukais = e.data[0].cukais
                            this.cukais13 = cukais.find(e => e.akaun_id == 13);
                            this.cukais28 = cukais.find(e => e.akaun_id == 28);
                        }
                    })
                    .finally((e) => {
                        (this.dialog.show = false), (this.searching = false);
                        this.hasSearched = true;
                    });
            } else {
                console.log("no data");
            }
        },
        focusTab(e) {
            this.form.kategori_carian = e.id;
        },

        async fetchData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
                this.form.kod_daerah = this.districts[0].value;
            });
        },

        async fetchData2() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisHm`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async fetchData1(w) {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah/${this.form.kod_daerah}/mukim`,
                responseType: "json",
            }).then((e) => {
                this.mukim = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },

        async init() {
            const res = await this.fetchData();
            const res1 = await this.fetchData1();
            const res2 = await this.fetchData2();
        },
    },

    mounted() {
        this.kategori(), this.init();
    },
};
</script>
